export const ClientPortalCollaborationEnum = {
  none: 'none',
  existing_only: 'existing_only',
  existing_and_add_new: 'existing_and_add_new',
} as const;
export type ClientPortalCollaborationEnum =
  (typeof ClientPortalCollaborationEnum)[keyof typeof ClientPortalCollaborationEnum];
